import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import { spacing } from "./armor-system-QCYY7333.js";

// src/properties/margin.ts
import { css } from "styled-components";
var marginProps = function marginProps(_ref) {
  var margin = _ref.margin,
    marginTop = _ref.marginTop,
    marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginRight = _ref.marginRight,
    marginX = _ref.marginX,
    marginY = _ref.marginY;
  var result = css(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
  if (typeof margin !== "undefined") {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            margin: ", ";\n        "])), result, spacing(margin));
  }
  if (typeof marginTop !== "undefined") {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            margin-top: ", ";\n        "])), result, spacing(marginTop));
  }
  if (typeof marginBottom !== "undefined") {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            margin-bottom: ", ";\n        "])), result, spacing(marginBottom));
  }
  if (typeof marginLeft !== "undefined") {
    result = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            ", ";\n            margin-left: ", ";\n        "])), result, spacing(marginLeft));
  }
  if (typeof marginRight !== "undefined") {
    result = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            ", ";\n            margin-right: ", ";\n        "])), result, spacing(marginRight));
  }
  if (typeof marginX !== "undefined") {
    var value = spacing(marginX);
    result = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            ", ";\n            margin-right: ", ";\n            margin-left: ", ";\n        "])), result, value, value);
  }
  if (typeof marginY !== "undefined") {
    var _value = spacing(marginY);
    result = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            ", ";\n            margin-top: ", ";\n            margin-bottom: ", ";\n        "])), result, _value, _value);
  }
  return result;
};
export { marginProps };